module.exports = __webpack_public_path__ + "static/media/rain.a99cf6dd.wav";